/**
 * Home Page Component
 * 
 * This is the main landing page for OceanNova.
 * It renders all sections in a structured, maintainable way using
 * a configuration-based approach.
 * 
 * The page structure includes:
 * - Navigation (Navbar)
 * - Hero section
 * - Content sections (Services, Client Success, Global Reach, etc.)
 * - Contact and Footer
 */

import { homeSections } from "@/config/homeSections";
import { SEO } from "@/components/SEO";
import { organizationSchema, websiteSchema, servicesListSchema } from "@/utils/structuredData";

/**
 * Index page component
 * 
 * Renders all home page sections in order based on the configuration
 * defined in src/config/homeSections.tsx
 */
const Index = () => {
  return (
    <>
      <SEO
        title="OceanNova | Shipyard, industrial and infrastructure projects"
        description="OceanNova organises teams, coordinates work and delivers the agreed scope on shipyard, industrial and infrastructure projects, plus shipping and logistics services."
        canonicalPath="/"
        structuredData={[organizationSchema, websiteSchema, servicesListSchema]}
        keywords={["shipyard work", "hull and welding work", "industrial assembly", "steel structures", "port infrastructure", "terminal development", "project cargo", "ship agency"]}
      />
      <div className="min-h-screen page-transition">
        {homeSections.map(({ id, component: Component }) => (
          <Component key={id} />
        ))}
      </div>
    </>
  );
};

export default Index;
